import { render } from "./WalletAddress.vue?vue&type=template&id=b9f6a6de&scoped=true"
import script from "./WalletAddress.vue?vue&type=script&lang=js"
export * from "./WalletAddress.vue?vue&type=script&lang=js"

import "./WalletAddress.vue?vue&type=style&index=0&id=b9f6a6de&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9f6a6de"]])

export default __exports__